// notifications.ts — Endpoints notifications + préférences user (mai 2026).
// Pas de perm — visibilité via object_rights.
import { req } from './_internals.js';

export const notificationsApi = {
  getMyNotifPrefs: () => req('GET', '/me/notification-preferences'),
  patchMyNotifPrefs: (d: unknown) => req('PATCH', '/me/notification-preferences', d),
  getMyCommitteeAlertPrefs: () => req('GET', '/me/committee-alert-preferences'),
  patchMyCommitteeAlertPrefs: (d: unknown) => req('PATCH', '/me/committee-alert-preferences', d),
  getMyMascotPrefs: () => req('GET', '/me/mascot-preferences'),
  patchMyMascotPrefs: (d: unknown) => req('PATCH', '/me/mascot-preferences', d),
  getNotifications: (qs = '') => req('GET', '/notifications' + (qs ? '?' + qs : '')),
  getNotificationsBadge: () => req('GET', '/notifications/badge-count'),
  getNotificationFilters: () => req('GET', '/notifications/filter-options'),
  markNotifRead: (id: number | string) => req('POST', '/notifications/' + id + '/read'),
  markNotifUnread: (id: number | string) => req('DELETE', '/notifications/' + id + '/read'),
};
